import { FC } from 'react';
import {
  Box,
  HStack,
  VStack,
  Text,
  Heading,
  Badge,
  StackDivider
} from '@chakra-ui/layout';
import CrucibleMetadata from 'helpers/nft/crucibleScene/crucibleMetadata';
import getName from 'helpers/nft/crucibleScene/getName';

type Props = {
  metadata: CrucibleMetadata;
  blockNumber: number;
  mintTimestamp: number;
};

const TraitsTable: FC<Props> = ({ metadata, blockNumber, mintTimestamp }) => {
  const traits = [
    {
      trait: 'Central Piece',
      name: metadata.centralPiece.name,
      weight: metadata.centralPiece.weight,
      event: metadata.centralPiece.event
    },
    {
      trait: 'Clock',
      name: metadata.clock.name,
      weight: metadata.clock.weight,
      event: metadata.clock.event
    },
    {
      trait: 'Planetary Clock',
      name: metadata.planetaryClock.name,
      weight: metadata.planetaryClock.weight,
      event: metadata.planetaryClock.event
    },
    {
      trait: 'Gyroscope',
      name: metadata.gyroscope.name,
      weight: metadata.gyroscope.weight,
      event: metadata.gyroscope.event
    },
    {
      trait: 'Runes',
      name: metadata.runes.name,
      weight: metadata.runes.weight,
      event: metadata.runes.event
    },
    {
      trait: 'Reward Program',
      name: metadata.rewardProgram.name,
      weight: metadata.rewardProgram.weight,
      event: metadata.rewardProgram.event
    },
    {
      trait: 'Gems',
      name: metadata.gems.name,
      weight: metadata.gems.weight,
      event: metadata.gems.event
    },
    {
      trait: 'Frame',
      name: metadata.frame.name,
      weight: metadata.frame.weight,
      event: metadata.frame.event
    },
    {
      trait: 'Multiplier',
      name: metadata.multiplier.name,
      weight: metadata.multiplier.weight,
      event: metadata.multiplier.event
    },
    {
      trait: 'Shell Glass',
      name: metadata.shellGlass.name,
      weight: metadata.shellGlass.weight,
      event: metadata.shellGlass.event
    },
    {
      trait: 'Shell Outer Ring',
      name: metadata.shellOuterRing.name,
      weight: metadata.shellOuterRing.weight,
      event: metadata.shellOuterRing.event
    },
    {
      trait: 'Shell Ornament Ring',
      name: metadata.shellOrnamentRing.name,
      weight: metadata.shellOrnamentRing.weight,
      event: metadata.shellOrnamentRing.event
    },
    {
      trait: 'Shell Inner Ring',
      name: metadata.shellInnerRing.name,
      weight: metadata.shellInnerRing.weight,
      event: metadata.shellInnerRing.event
    },
    {
      trait: 'Shell Cut Shape',
      name: metadata.shellCutShape.name,
      weight: metadata.shellCutShape.weight,
      event: metadata.shellCutShape.event
    }
  ];

  return (
    <Box
      m={4}
      p={[4, 4, 8]}
      top={16}
      bottom={0}
      left={0}
      overflowY='auto'
      maxWidth={'380px'}
      borderRadius='md'
      bg='whiteAlpha.100'
      position='absolute'
      backdropFilter='blur(100px)'
      zIndex={1}
      sx={{
        '::-webkit-scrollbar': {
          width: '20px'
        },
        '::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: 'whiteAlpha.300',
          borderRadius: '20px',
          border: '6px solid transparent',
          backgroundClip: 'content-box'
        }
      }}
    >
      <VStack textAlign='left' alignItems='stretch' divider={<StackDivider />}>
        <Heading size='lg'>Traits</Heading>
        <VStack alignItems='stretch'>
          <Text color='gray.200'>Name</Text>
          <Text>
            {getName(metadata.crucibleId, blockNumber, mintTimestamp)}
          </Text>
        </VStack>
        {traits.map((trait) => (
          <VStack key={trait.name} alignItems='stretch'>
            <Text color='gray.200'>{trait.trait}</Text>
            <HStack>
              <Text>{trait.name}</Text>
              <Badge colorScheme='cyan' fontSize='sm'>
                {trait.event ? 'Event' : +(trait.weight / 100).toFixed(4)}%
              </Badge>
            </HStack>
          </VStack>
        ))}
      </VStack>
    </Box>
  );
};

export default TraitsTable;
